<ags-header routerLinkHome="/" [hideLiveNotification]="true" [disableFeedback]="true" agsUserMenuFix>
  <li class="nav-item">
    <a class="nav-link" routerLink="/plans/all">Planned Quota</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="/capacity/blueprints">Capacity</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="/create-request">On Demand Quota</a>
  </li>
  <li class="nav-item" *ngIf="userProfile?.IsAdmin || userProfile?.IsFfpAdmin">
    <a class="nav-link" routerLink="ffp/all">FFP</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="pf/all">PF</a>
  </li>
  <li *ngIf="betEnabled" class="nav-item">
    <a *ngIf="betUiUrl; else inAppBilling" class="nav-link" [href]="betUiUrl + '/quota/prep/status'">Billing Meter</a>
    <ng-template #inAppBilling>
      <a class="nav-link" routerLink="/prep/status">Billing Meter</a>
    </ng-template>
  </li>
  <li class="nav-item" *ngIf="userProfile?.IsAdmin || userProfile?.IsApproverAdmin">
    <a class="nav-link" routerLink="/approver-admin">Administration</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="/self-service/region-information">Self Service</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="https://aka.ms/lionrocksupport" target="_blank">Support</a>
  </li>
</ags-header>
<main class="d-flex" style="height: calc(100% - 50px); padding-bottom: 37px">
  <div class="sidebar" *ngIf="hasModuleNavItems()">
    <ags-side-navigation [navItems]="getModuleNavItems()"></ags-side-navigation>
  </div>
  <div class="flex-grow-1" style="height: 100%; overflow-y: auto">
    <div *ngIf="isTestEnv" class="alert alert-danger" role="alert" style="margin-bottom: 0; text-align: center">
      Quota or access is not really granted in this TEST environment.
    </div>
    <router-outlet></router-outlet>
  </div>
</main>

<em-loading-screen></em-loading-screen>
<ags-footer [fixedToBottom]="true">
  <div style="white-space: nowrap; text-align: center">
    <span style="padding: 0.25rem; color: red">Microsoft Confidential</span>
  </div>
</ags-footer>
